import { useState, useEffect } from 'react';
import { Agency } from '../utils/types';
import { UserState } from '../hooks/useUser';
import { getAgencies } from './agenciesService';

const useAgenciesData = (user: UserState | null) => {
  const [agencies, setAgencies] = useState<Agency[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }

    const fetchData = async () => {
      try {
        const { data } = await getAgencies(user?.accessToken);

        if (data) {
          setAgencies(data);
        } else if (error) {
          setError(error);
        }
      } catch (error: any) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user]);

  return { agencies, loading, setError, error };
};

export default useAgenciesData;